import React, { useState, useEffect, useMemo } from "react";
import { Card, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row, TabContent, TabPane, UncontrolledDropdown } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import classnames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { fetchBookingsDetailsData } from "../../store/bookings/actions";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import BookingRouteMap from "../../components/Common/BookingRouteMap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const BookingsDetails = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector(state => state.Bookings.details);

    useEffect(() => {
        if (id) {
            dispatch(fetchBookingsDetailsData(id));
        }
    }, [dispatch, id]);

    // Custom Tabs Bordered
    const [customActiveTab, setcustomActiveTab] = useState("1");
    const toggleCustom = (tab) => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab);
        }
    };

    const bookingTracking = {
        "booking_created": {
            "name": "Booking Created",
            "icon": "mdi mdi-calendar-plus",
            "class": "info",
        },
        "ongoing": {
            "name": "Booking Accepted",
            "icon": "mdi mdi-account-check-outline",
            "class": "warning",
        },
        "arrived": {
            "name": "Booking Arrived",
            "icon": "mdi mdi-map-marker-radius",
            "class": "secondary",
        },
        "hooked": {
            "name": "Hooked",
            "icon": "mdi mdi-car-outline",
            "class": "success",
        },
        "loading_proccess": {
            "name": "Loading Proccess",
            "icon": "mdi mdi-calendar-plus",
            "class": "purple",
        },
        "start": {
            "name": "Booking Started",
            "icon": "mdi mdi-car-outline",
            "class": "success",
        },
        "unloading_proccess": {
            "name": "Un-loading Proccess",
            "icon": "mdi mdi-calendar-plus",
            "class": "warning",
        },
        "complete": {
            "name": "Booking Complete",
            "icon": "mdi mdi-flag-checkered",
            "class": "dark",
        },
        "payment_collect": {
            "name": "Payment Collected",
            "icon": "mdi mdi-cash-multiple",
            "class": "success",
        },
    };

    document.title = "Bookings Details | Moeen";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs maintitle="Home" title="Bookings" breadcrumbItem="Bookings Details" />

                    <Row>
                        <Col xl={3}>
                            <div className="user-sidebar">
                                {/* Booking Status */}
                                <Card className="text-white" style={{ backgroundColor: '#6B0729', border: 'none' }}>
                                    <div className="p-4">
                                        <h5 className="mb-0 text-center">
                                            <span className="text-uppercase">
                                                {loading ? (
                                                    <Skeleton width={80} />
                                                ) : (
                                                    data?.data?.booking?.status || 'PENDING'
                                                )}
                                            </span>
                                        </h5>
                                    </div>
                                </Card>

                                {/* Customer Card */}
                                <Card className="position-relative">
                                    <CardBody>
                                        <div className="mt-n4 position-relative">
                                            {loading ? (
                                                <div className="text-center">
                                                    <Skeleton count={3} height={80} style={{ marginBottom: "10px" }} />
                                                </div>
                                            ) : data?.data?.customers && data.data.customers.length > 0 ? (
                                                <div
                                                    style={{
                                                        maxHeight: "350px",
                                                        overflowY: "auto",
                                                        paddingRight: "5px",
                                                    }}
                                                >
                                                    {data.data.customers.map((customer, index) => (
                                                        <div
                                                            key={index}
                                                            className="d-flex align-items-center border rounded p-2 mb-2"
                                                            style={{
                                                                backgroundColor: "#fafafa",
                                                                transition: "0.3s",
                                                            }}
                                                        >
                                                            <img
                                                                src={customer?.image || "/default-avatar.png"}
                                                                alt={customer?.name}
                                                                className="rounded-circle"
                                                                height="55"
                                                                width="55"
                                                            />
                                                            <div className="ms-3 flex-grow-1">
                                                                <h6 className="mb-0 text-dark">{customer?.name || "N/A"}</h6>
                                                                <small className="text-muted">
                                                                    {customer?.phone_code} {customer?.mobno}
                                                                </small>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="text-center text-muted">No Customers Found</div>
                                            )}
                                        </div>
                                    </CardBody>
                                </Card>

                                {/* Driver Card */}
                                <Card className="position-relative">
                                    <div
                                        className="position-absolute bg-t-primary text-white px-3 py-1"
                                        style={{
                                            top: "10px",
                                            right: "-10px",
                                            borderTopLeftRadius: "0",
                                            borderBottomLeftRadius: "0",
                                            borderTopRightRadius: "8px",
                                            borderBottomRightRadius: "8px",
                                            zIndex: 1,
                                        }}
                                    >
                                        Driver
                                    </div>
                                    <CardBody>
                                        <div className="mt-n4 position-relative">
                                            <div className="text-center">
                                                {loading ? (
                                                    <Skeleton circle height={80} width={80} />
                                                ) : (
                                                    <img
                                                        src={data?.data?.driver?.image}
                                                        alt={data?.data?.driver?.name}
                                                        className="avatar-xl rounded-circle img-thumbnail"
                                                    />
                                                )}
                                                <div className="mt-3">
                                                    <h5>{loading ? <Skeleton width={100} /> : data?.data?.driver?.name}</h5>
                                                    <div>
                                                        {loading ? (
                                                            <Skeleton width={140} />
                                                        ) : (
                                                            <Link to="#" className="text-muted m-1">
                                                                {data?.data?.driver?.phone_code} {data?.data?.driver?.mobno}
                                                            </Link>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>

                                {/* Vehicle Card */}
                                <Card className="position-relative">
                                    <div
                                        className="position-absolute bg-t-primary text-white px-3 py-1"
                                        style={{
                                            top: "10px",
                                            right: "-10px",
                                            borderTopLeftRadius: "0",
                                            borderBottomLeftRadius: "0",
                                            borderTopRightRadius: "8px",
                                            borderBottomRightRadius: "8px",
                                            zIndex: 1,
                                        }}
                                    >
                                        Vehicle
                                    </div>
                                    <CardBody>
                                        <div className="mt-n4 position-relative">
                                            <div className="text-center">
                                                {loading ? (
                                                    <Skeleton circle height={80} width={80} />
                                                ) : (
                                                    <img
                                                        src={data?.data?.vehicle?.vehicle_media?.[0]?.url}
                                                        alt={data?.data?.vehicle?.make_name}
                                                        className="avatar-xl rounded-circle img-thumbnail"
                                                    />
                                                )}
                                                <div className="mt-3">
                                                    <h5>
                                                        {loading ? (
                                                            <Skeleton width={120} />
                                                        ) : (
                                                            `${data?.data?.vehicle?.make_name} - ${data?.data?.vehicle?.body_type}`
                                                        )}
                                                    </h5>
                                                    <div>
                                                        {loading ? (
                                                            <Skeleton width={160} />
                                                        ) : (
                                                            <Link to="#" className="text-muted m-1">
                                                                {data?.data?.vehicle?.license_plate} - {data?.data?.vehicle?.type_name}
                                                            </Link>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                        </Col>

                        <Col xl={9}>

                            <Card>
                                <Nav tabs className="nav nav-tabs nav-tabs-custom nav-justified">
                                    <NavItem>
                                        <NavLink
                                            style={{ cuLYDor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "1",
                                            })}
                                            onClick={() => {
                                                toggleCustom("1");
                                            }}
                                        >
                                            <i className="bx bx-user-circle font-size-20"></i>
                                            <span className="d-none d-sm-block">Location</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cuLYDor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "2",
                                            })}
                                            onClick={() => {
                                                toggleCustom("2");
                                            }}
                                        >
                                            <i className="bx bx-clipboard font-size-20"></i>
                                            <span className="d-none d-sm-block">Tracking</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cuLYDor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "3",
                                            })}
                                            onClick={() => {
                                                toggleCustom("3");
                                            }}
                                        >
                                            <i className="bx bx-mail-send font-size-20"></i>
                                            <span className="d-none d-sm-block">Fares</span>
                                        </NavLink>
                                    </NavItem>
                                    {data?.data?.booking?.type === 'towing' ? (
                                        <NavItem>
                                            <NavLink
                                                style={{ cuLYDor: "pointer" }}
                                                className={classnames({
                                                    active: customActiveTab === "4",
                                                })}
                                                onClick={() => {
                                                    toggleCustom("4");
                                                }}
                                            >
                                                <i className="bx bx-mail-send font-size-20"></i>
                                                <span className="d-none d-sm-block">Towing Details</span>
                                            </NavLink>
                                        </NavItem>
                                    ) : null}
                                    {data?.data?.booking?.type === 'industrial' ? (
                                        <NavItem>
                                            <NavLink
                                                style={{ cuLYDor: "pointer" }}
                                                className={classnames({
                                                    active: customActiveTab === "4",
                                                })}
                                                onClick={() => {
                                                    toggleCustom("4");
                                                }}
                                            >
                                                <i className="bx bx-mail-send font-size-20"></i>
                                                <span className="d-none d-sm-block">Industrial Details</span>
                                            </NavLink>
                                        </NavItem>
                                    ) : null}
                                </Nav>

                                <TabContent
                                    activeTab={customActiveTab}
                                    className="p-4"
                                >
                                    <TabPane tabId="1">

                                        <div>
                                            <div>
                                                <h5 className="font-size-16 mb-4">Locations</h5>

                                                <ol className="activity-checkout mb-0 px-4 mt-3">
                                                    <li className="checkout-item">
                                                        <div className="avatar-sm checkout-icon p-1">
                                                            <div className="avatar-title rounded-circle bg-primary">
                                                                <i className="mdi mdi-map-marker text-white font-size-20"></i>
                                                            </div>
                                                        </div>
                                                        <div className="feed-item-list">
                                                            <div>
                                                                <h5 className="font-size-16 mb-1">{loading ? <Skeleton width={200} /> : data?.data?.booking?.pickup_addr}</h5>
                                                                {loading ? (
                                                                    <Skeleton width={150} />
                                                                ) : data?.data?.booking?.tracking?.[1]?.datetime && (
                                                                    <p className="text-muted text-truncate mb-2">
                                                                        {data.data.booking.tracking[1].datetime}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </li>

                                                    <li className="checkout-item">
                                                        <div className="avatar-sm checkout-icon p-1">
                                                            <div className="avatar-title rounded-circle bg-primary">
                                                                <i className="mdi mdi-map-marker-check text-white font-size-20"></i>
                                                            </div>
                                                        </div>
                                                        <div className="feed-item-list">

                                                            <h5 className="font-size-16 mb-1">{loading ? <Skeleton width={200} /> : data?.data?.booking?.dest_addr}</h5>
                                                            {loading ? (
                                                                <Skeleton width={150} />
                                                            ) : data?.data?.booking?.tracking?.[5]?.datetime && (
                                                                <p className="text-muted text-truncate mb-2">
                                                                    {data.data.booking.tracking[5].datetime}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </li>

                                                </ol>
                                            </div>

                                            <div>
                                                <h5 className="font-size-16 mb-4">Map</h5>
                                                {loading ? (
                                                    <Skeleton height={300} />
                                                ) : (
                                                    <BookingRouteMap
                                                        src_lat={data?.data?.booking?.source_lat}
                                                        src_lng={data?.data?.booking?.source_long}
                                                        dest_lat={data?.data?.booking?.dest_lat}
                                                        dest_lng={data?.data?.booking?.dest_long}
                                                    />
                                                )}
                                            </div>
                                        </div>

                                    </TabPane>
                                    <TabPane tabId="2">

                                        <div>
                                            <div>
                                                <h5 className="font-size-16 mb-4">Booking Tracking</h5>

                                                <ol className="activity-checkout mb-0 px-4 mt-3">

                                                    {data?.data?.booking?.tracking?.map((track, index) => {
                                                        const trackInfo = bookingTracking[track.status];
                                                        if (!trackInfo) return null;

                                                        return (
                                                            <li key={index} className="checkout-item">
                                                                <div className="avatar-sm checkout-icon p-1">
                                                                    <div className={`avatar-title rounded-circle bg-${trackInfo.class}`}>
                                                                        <i className={`${trackInfo.icon} text-white font-size-20`}></i>
                                                                    </div>
                                                                </div>
                                                                <div className="feed-item-list">
                                                                    <h5 className="font-size-16 mb-1">{trackInfo.name}</h5>
                                                                    {track.datetime && (
                                                                        <p className="text-muted text-truncate mb-2">{track.datetime}</p>
                                                                    )}
                                                                </div>
                                                            </li>
                                                        );
                                                    })}

                                                </ol>

                                            </div>
                                        </div>

                                    </TabPane>
                                    <TabPane tabId="3">

                                        <div>
                                            <h5 className="font-size-16 mb-3">Fare Summary</h5>

                                            {/* Booking & Ride Details */}
                                            <div className="mb-4 p-3 border rounded bg-light">
                                                <h6 className="mb-3">Ride Details</h6>
                                                <div className="row">
                                                    <div className="col-md-6 mb-2">
                                                        <strong>Pickup Location:</strong>
                                                        <p className="mb-0">
                                                            {loading ? <Skeleton width={180} /> : data?.data?.booking?.pickup_addr}
                                                        </p>
                                                    </div>
                                                    <div className="col-md-6 mb-2">
                                                        <strong>Drop-off Location:</strong>
                                                        <p className="mb-0">
                                                            {loading ? <Skeleton width={180} /> : data?.data?.booking?.dest_addr}
                                                        </p>
                                                    </div>
                                                    <div className="col-md-6 mb-2">
                                                        <strong>Booking Type:</strong>
                                                        <p className="mb-0 text-capitalize">
                                                            {loading ? <Skeleton width={100} /> : data?.data?.booking?.type}
                                                        </p>
                                                    </div>
                                                    <div className="col-md-6 mb-2">
                                                        <strong>Distance:</strong>
                                                        <p className="mb-0">
                                                            {loading ? <Skeleton width={60} /> : `${data?.data?.booking?.total_kms} km`}
                                                        </p>
                                                    </div>
                                                    <div className="col-md-6 mb-2">
                                                        <strong>Payment Method:</strong>
                                                        <p className="mb-0 text-capitalize">
                                                            {loading ? <Skeleton width={120} /> : data?.data?.booking?.payment_method}
                                                        </p>
                                                    </div>
                                                    <div className="col-md-6 mb-2">
                                                        <strong>Payment Status:</strong>
                                                        <p className="mb-0 text-capitalize">
                                                            {loading ? (
                                                                <Skeleton width={80} />
                                                            ) : data?.data?.booking?.payment_status == 1 ? (
                                                                "Paid"
                                                            ) : (
                                                                "Not Paid"
                                                            )}
                                                        </p>
                                                    </div>
                                                    <div className="col-md-6 mb-2">
                                                        <strong>Is Scheduled?:</strong>
                                                        <p className="mb-0 text-capitalize">
                                                            {loading ? (
                                                                <Skeleton width={80} />
                                                            ) : data?.data?.booking?.is_scheduled == 1 ? (
                                                                "YES"
                                                            ) : (
                                                                "NO"
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Fare Breakdown Table */}
                                            <div className="table-responsive">
                                                <table className="table table-bordered mb-0">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th>Fare Type</th>
                                                            <th>Amount (LYD)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {loading ? (
                                                            Array.from({ length: 5 }).map((_, idx) => (
                                                                <tr key={idx}>
                                                                    <td>
                                                                        <Skeleton width={120} />
                                                                    </td>
                                                                    <td>
                                                                        <Skeleton width={80} />
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <>
                                                                <tr>
                                                                    <td>Base Fare</td>
                                                                    <td>{data?.data?.booking?.base_fare?.toFixed(2)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Standard Fare (Distance)</td>
                                                                    <td>{data?.data?.booking?.std_fare?.toFixed(2)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Time Fare</td>
                                                                    <td>{data?.data?.booking?.time_rate?.toFixed(2)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Other Charges</td>
                                                                    <td>{data?.data?.booking?.other_fee?.toFixed(2)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>VAT Charges</td>
                                                                    <td>{data?.data?.booking?.vat_charges?.toFixed(2)}</td>
                                                                </tr>
                                                                {data?.data?.booking?.type == 'industrial' && data?.data?.booking?.industrial_details?.is_worker_required == 1 ? (
                                                                    <tr>
                                                                        <td>Number of Workers ({data?.data?.booking?.industrial_details?.number_of_worker})</td>
                                                                        <td>{data?.data?.booking?.industrial_details?.number_of_worker * 50}</td>
                                                                    </tr>
                                                                ) : null}
                                                                <tr className="table-active font-weight-bold">
                                                                    <td>Total Fare</td>
                                                                    <td>{data?.data?.booking?.total_amount?.toFixed(2)}</td>
                                                                </tr>
                                                            </>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    </TabPane>
                                    {data?.data?.booking?.type === 'towing' ? (
                                        <TabPane tabId="4">

                                            <div className="mt-4">
                                                <Card className="shadow-lg border-0 rounded-3 overflow-hidden">
                                                    <CardBody>
                                                        <h4 className="mb-4 text-primary fw-bold">Towing Details</h4>

                                                        <Row className="align-items-center mb-4">
                                                            <Col md={7}>
                                                                <div className="p-3">
                                                                    <h5 className="fw-semibold mb-3">Vehicle Information</h5>
                                                                    <ul className="list-unstyled mb-0">
                                                                        <li className="mb-2">
                                                                            <strong>Body Type:</strong>{" "}
                                                                            {loading ? (
                                                                                <Skeleton width={100} />
                                                                            ) : (
                                                                                data?.data?.booking?.twing_details?.vehicle_body_type_name
                                                                            )}
                                                                        </li>
                                                                        <li className="mb-2">
                                                                            <strong>Registration No:</strong>{" "}
                                                                            {loading ? (
                                                                                <Skeleton width={120} />
                                                                            ) : (
                                                                                data?.data?.booking?.twing_details?.registration_number
                                                                            )}
                                                                        </li>
                                                                        <li className="mb-2">
                                                                            <strong>Passengers:</strong>{" "}
                                                                            {loading ? (
                                                                                <Skeleton width={50} />
                                                                            ) : (
                                                                                data?.data?.booking?.twing_details?.number_of_passenger
                                                                            )}
                                                                        </li>
                                                                        <li className="mb-2">
                                                                            <strong>Issue:</strong>{" "}
                                                                            {loading ? <Skeleton width={150} /> : data?.data?.booking?.twing_details?.issue}
                                                                        </li>
                                                                        <li className="mb-2">
                                                                            <strong>Customer Contact:</strong>{" "}
                                                                            {loading ? (
                                                                                <Skeleton width={150} />
                                                                            ) : (
                                                                                data?.data?.booking?.twing_details?.customer_mob || "N/A"
                                                                            )}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </Col>

                                                            <Col md={5} className="text-center">
                                                                {loading ? (
                                                                    <Skeleton height={200} width={250} />
                                                                ) : (
                                                                    <img
                                                                        src={data?.data?.booking?.twing_details?.vehicle_body_type_image}
                                                                        alt="Vehicle"
                                                                        className="img-fluid rounded shadow-sm"
                                                                        style={{ maxHeight: "220px", objectFit: "cover" }}
                                                                    />
                                                                )}
                                                            </Col>
                                                        </Row>

                                                        {data?.data?.booking?.twing_details?.is_garage == 1 ? (
                                                            <div className="p-3 bg-light rounded">
                                                                <h5 className="fw-semibold mb-3">🛠 Garage Information</h5>
                                                                <Row className="align-items-center">
                                                                    <Col md={4} className="text-center mb-3 mb-md-0">
                                                                        {loading ? (
                                                                            <Skeleton height={180} width={220} />
                                                                        ) : (
                                                                            <img
                                                                                src={data?.data?.booking?.twing_details?.garage_image}
                                                                                alt="Garage"
                                                                                className="img-fluid rounded shadow-sm"
                                                                                style={{ maxHeight: "200px", objectFit: "cover" }}
                                                                            />
                                                                        )}
                                                                    </Col>

                                                                    <Col md={8}>
                                                                        <h6 className="fw-bold">
                                                                            {loading ? <Skeleton width={150} /> : data?.data?.booking?.twing_details?.garage_name}
                                                                        </h6>
                                                                        <p className="mb-2 text-muted">
                                                                            {loading ? (
                                                                                <Skeleton width={250} />
                                                                            ) : (
                                                                                data?.data?.booking?.twing_details?.garage_address
                                                                            )}
                                                                        </p>
                                                                        <p className="mb-0">
                                                                            {loading ? (
                                                                                <Skeleton count={2} />
                                                                            ) : (
                                                                                data?.data?.booking?.twing_details?.garage_description
                                                                            )}
                                                                        </p>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        ) : null}
                                                    </CardBody>
                                                </Card>
                                            </div>

                                        </TabPane>
                                    ) : null}
                                    {data?.data?.booking?.type === 'industrial' ? (
                                        <TabPane tabId="4">

                                            <div className="industrial-details p-4">
                                                <Card className="shadow-lg border-0 rounded-4 overflow-hidden">
                                                    <CardBody>
                                                        <Row>
                                                            <Col md="7" className="pe-4">
                                                                <h3 className="fw-bold mb-4" style={{ color: "#1a1a1a" }}>
                                                                    Industrial Shipment Details
                                                                </h3>

                                                                <div className="mb-3">
                                                                    <p className="text-muted mb-1">Main Item</p>
                                                                    <h5>{data?.data?.booking?.industrial_details?.main_type_of_items}</h5>
                                                                </div>

                                                                <div className="mb-3">
                                                                    <p className="text-muted mb-1">Material</p>
                                                                    <h5>{data?.data?.booking?.industrial_details?.material_name}</h5>
                                                                </div>

                                                                <Row>
                                                                    <Col md="6" className="mb-3">
                                                                        <p className="text-muted mb-1">Weight</p>
                                                                        <h6>{data?.data?.booking?.industrial_details?.weight} kg</h6>
                                                                    </Col>
                                                                    <Col md="6" className="mb-3">
                                                                        <p className="text-muted mb-1">Number of Items</p>
                                                                        <h6>{data?.data?.booking?.industrial_details?.number_of_items}</h6>
                                                                    </Col>
                                                                </Row>

                                                                <Row>
                                                                    <Col md="6" className="mb-3">
                                                                        <p className="text-muted mb-1">Pickup Floor</p>
                                                                        <h6>{data?.data?.booking?.industrial_details?.pickup_floor}</h6>
                                                                    </Col>
                                                                    <Col md="6" className="mb-3">
                                                                        <p className="text-muted mb-1">Elevator Available</p>
                                                                        <h6>{data?.data?.booking?.industrial_details?.is_elevator ? "Yes" : "No"}</h6>
                                                                    </Col>
                                                                </Row>
                                                            </Col>

                                                            <Col md="5">
                                                                <div>
                                                                    <h5 className="fw-bold mb-3">Material Images</h5>
                                                                    <div className="d-flex flex-wrap gap-3">
                                                                        {data?.data?.booking?.industrial_details?.material_images?.map((img, index) => (
                                                                            <div
                                                                                key={index}
                                                                                className="shadow-sm rounded-3"
                                                                                style={{
                                                                                    width: "48%",
                                                                                    background: "#fafafa",
                                                                                    overflow: "hidden",
                                                                                }}
                                                                            >
                                                                                <img
                                                                                    src={img.url}
                                                                                    alt={`material-${index}`}
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        height: "120px",
                                                                                        objectFit: "cover",
                                                                                        borderRadius: "10px",
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                        <div className="mt-4 p-3 rounded-4 shadow-sm" style={{ background: "#f8f9fa" }}>
                                                            <Row>
                                                                <Col md="4">
                                                                    <p className="text-muted mb-1">Workers Required</p>
                                                                    <h6>
                                                                        {data?.data?.booking?.industrial_details?.is_worker_required ? "Yes" : "No"}
                                                                    </h6>
                                                                </Col>
                                                                <Col md="4">
                                                                    <p className="text-muted mb-1">Disassembled</p>
                                                                    <h6>{data?.data?.booking?.industrial_details?.items_disassembled ? "Yes" : "No"}</h6>
                                                                </Col>
                                                                <Col md="4">
                                                                    <p className="text-muted mb-1">Number of Workers</p>
                                                                    <h6>{data?.data?.booking?.industrial_details?.number_of_worker}</h6>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </div>

                                        </TabPane>
                                    ) : null}
                                </TabContent>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default BookingsDetails;
